<template>
  <div id="DeliveryKeywordMgmt" style="width: 100%; margin: 0 auto; background: white">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">机型</span>
        <el-select placeholder="产品机型" size="small" v-model="productModel">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
        <span class="header-label">匹配类型</span>
        <el-select placeholder="匹配类型" size="small" v-model="params.matchType">
          <el-option label="全部" value=""></el-option>
          <el-option label="精准匹配" value="exact"></el-option>
          <el-option label="词组匹配" value="phrase"></el-option>
          <el-option label="宽泛匹配" value="loose"></el-option>
        </el-select>
        <span class="header-label">状态</span>
        <el-select placeholder="匹配类型" size="small" v-model="params.State">
          <el-option label="全部" value=""></el-option>
          <el-option label="已启用" value="已启用"></el-option>
          <el-option label="已暂停" value="已暂停"></el-option>
        </el-select>
        <span class="header-label">排序类型</span>
        <el-select placeholder="排序类型" size="small" v-model="params.sortKey">
          <el-option label="花费" value="Spend"></el-option>
          <el-option label="单价" value="Bid"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku"> </el-input>
        <span class="header-label">Asin</span>
        <el-input placeholder="请输入Asin" size="small" clearable v-model="params.asin"> </el-input>
        <span class="header-label">关键词</span>
        <el-input placeholder="请输入关键词" size="small" clearable v-model="params.keyword"> </el-input>
        <span class="header-label">KWModel</span>
        <el-input placeholder="KWModel" size="small" clearable v-model="params.keywordModel"> </el-input>
        <span class="header-label">PhoneModel</span>
        <el-input placeholder="KWModel" size="small" clearable v-model="params.phoneModelKW"> </el-input>
        <span class="header-label">日期</span>
        <el-date-picker v-model="params.date" type="date" placeholder="选择日期" style="width: 150px"> </el-date-picker>
      </div>
      <div class="header-line">
        <el-button type="primary" size="small" @click="getAdvertData">查询</el-button>
        <el-button type="primary" size="small" @click="addKeywords">新增</el-button>
        <el-button type="primary" size="small" @click="autoAddKeywords">一键新增</el-button>
        <el-button type="primary" size="small" @click="autoAdjustKeywords">一键调整</el-button>
        <el-button type="primary" size="small" @click="batchUpdateKWModel">批量KWModel</el-button>
        <el-button type="primary" size="small" @click="startKWAdvertTask">生成数据</el-button>
        <el-button type="primary" size="small" @click="priceBtn">批量改价</el-button>
        <el-button type="primary" size="small" @click="autoAdjustBtn">批量调整</el-button>
      </div>
    </div>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" row-key="_id" lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :highlight-current-row="true" border @selection-change="handleSelectionChange" show-summary :summary-method="getSummaries">
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column width="50px"> </el-table-column>
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="keywordAnalysis(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="60px" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.State" v-if="scope.row.productAd != 1" @change="onStateChange(scope.row)" size="mini" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="recommandState" label="推荐状态" width="50px">
        <template v-slot="scope">
          <div :class="getRecommandStateStyleClass(scope.row)">{{ scope.row.recommandState }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="weight" label="权重" width="60px" align="right"> </el-table-column> -->
      <el-table-column prop="sku" label="SKU" width="200px" sortable> </el-table-column>
      <!-- <el-table-column prop="asin" label="Asin" width="100px"> </el-table-column> -->
      <el-table-column label="产品信息" width="80px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label">{{ scope.row.productName }}</div>
          <div class="row-label">{{ scope.row.productColorName }}</div>
          <div class="row-label">{{ scope.row.model }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="productName" label="产品名称" width="80px" sortable> </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="80px" sortable> </el-table-column>
      <el-table-column prop="model" label="机型" width="80px" sortable> </el-table-column> -->
      <el-table-column prop="Keyword Text" label="关键词" width="200px" sortable>
        <template slot-scope="scope">
          <div class="row-label">{{ scope.row["Keyword Text"] }}</div>
          <div class="row-label">{{ "周搜索量：" + scope.row.queryQuantity }}</div>
          <div class="row-label">{{ "搜索排名：" + scope.row.rank }}</div>
          <div class="row-label">{{ scope.row["Ad Group Name (Informational only)"] }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="queryQuantity" label="周搜索量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="rank" label="搜索排名" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Match Type" label="匹配类型" width="60px" align="center" sortable> </el-table-column>
      <el-table-column prop="traffic" label="流量" width="110px" sortable>
        <template slot-scope="scope">
          <div class="row-label">
            <span>流____量：</span>
            <span style="float: right">{{ scope.row.traffic ? scope.row.traffic : "" }}</span>
          </div>
          <div class="row-label">
            <span>流量占比：</span>
            <span style="float: right">{{ scope.row.trafficProportion ? (scope.row.trafficProportion * 100).toFixed(2) + "%" : "" }}</span>
          </div>
          <div class="row-label">
            <span>自然流量：</span>
            <span style="float: right">{{ scope.row.organicTrafficProportion ? scope.row.organicTrafficProportion.toFixed(2) + "%" : "" }}</span>
          </div>
          <div class="row-label">
            <span>广告流量：</span>
            <span style="float: right">{{ scope.row.advertTrafficProportion ? scope.row.advertTrafficProportion.toFixed(2) + "%" : "" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="organicRank" label="排名" width="110px" sortable>
        <template slot-scope="scope">
          <div class="row-label">
            <span>排____名：</span>
            <span style="float: right">{{ scope.row.organicRank ? scope.row.organicRank : "" }}</span>
          </div>
          <div class="row-label">
            <span>排名页码：</span>
            <span style="float: right">{{ scope.row.organicRankPagePosition ? scope.row.organicRankPagePosition : "" }}</span>
          </div>
          <div class="row-label">
            <span>广告排名：</span>
            <span style="float: right">{{ scope.row.spAdvertRank ? scope.row.spAdvertRank : "" }}</span>
          </div>
          <div class="row-label">
            <span>广告页码：</span>
            <span style="float: right">{{ scope.row.spAdvertRankPagePosition ? scope.row.spAdvertRankPagePosition : "" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="相关变体" width="150px" sortable>
        <template slot-scope="scope">
          <div class="row-label">{{ scope.row.relateAsinLabel0 ? scope.row.relateAsinLabel0 : "" }}</div>
          <div class="row-label">{{ scope.row.relateAsinLabel1 ? scope.row.relateAsinLabel1 : "" }}</div>
          <div class="row-label">{{ scope.row.relateAsinLabel2 ? scope.row.relateAsinLabel2 : "" }}</div>
          <div class="row-label">{{ scope.row.relateAsinLabel3 ? scope.row.relateAsinLabel3 : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Bid" label="单价" width="80px" align="right" sortable>
        <template slot-scope="scope">
          <el-input v-model="scope.row.Bid" @change="onBidChange(scope.row)" size="mini" v-if="scope.row.productAd != 1"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="推荐标题" width="80px" align="right">
        <template slot-scope="scope">
          <div class="row-label">Bid</div>
          <div class="row-label" v-if="scope.row.recommandType != 10">KWModel</div>
          <div class="row-label" v-if="scope.row.recommandType == 10">核心词</div>
          <div class="row-label">预期转化率</div>
          <div class="row-label">CPS</div>
          <div class="row-label">推荐类型</div>
        </template>
      </el-table-column>
      <el-table-column label="推荐单价" width="200px" align="left" sortable>
        <template slot-scope="scope">
          <div class="row-label" :class="getRecommandBidStyleClass(scope.row)" @click="onRecommandBidClick(scope.row)" style="cursor: pointer">{{ scope.row.recommandBid }}</div>
          <div class="row-label" v-if="scope.row.recommandType != 10">{{ scope.row.keywordModel }}</div>
          <div class="row-label" v-if="scope.row.recommandType == 10">{{ scope.row.coreWord }}</div>
          <div class="row-label">{{ (scope.row.expectedRate * 100).toFixed(2) + "%" }}</div>
          <div class="row-label">{{ scope.row.expectedCps }}</div>
          <div class="row-label">{{ getRecommandTypeLabel(scope.row.recommandType) }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="recommandBid" label="推荐单价" width="40px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getRecommandBidStyleClass(scope.row)" @click="onRecommandBidClick(scope.row)" style="cursor: pointer">{{ scope.row.recommandBid }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="CPC" label="CPC" width="60px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.CPC.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Impressions" label="展现量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Clicks" label="点击量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.Spend.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售额" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.Sales.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Units" label="销售数量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Conversion Rate" label="点击转化率" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div>{{ Math.round(scope.row["Conversion Rate"] * 10000) / 100 + "%" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="60px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.ROAS.toFixed(2) }}
        </template>
      </el-table-column> -->

      <el-table-column label="标题" width="90px" align="right">
        <div>
          <div class="row-label grayBg">最近-广告表现</div>
          <div class="row-label">投放-近90日</div>
          <div class="row-label">投放-近30日</div>
          <div class="row-label">投放-近14日</div>
          <div>投放-近7日</div>
        </div>
      </el-table-column>
      <el-table-column prop="CPC" label="CPC" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.CPC.toFixed(2) }}</div>
          <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
            <div class="row-label">{{ scope.row.deliveryPerformance.last90DayCPC.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.deliveryPerformance.last30DayCPC.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.deliveryPerformance.last14DayCPC.toFixed(2) }}</div>
            <div>{{ scope.row.deliveryPerformance.last7DayCPC.toFixed(2) }}</div>
          </div>
          <div v-else>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Impressions" label="展现" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.Impressions }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last90DayImpressions }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last30DayImpressions }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last14DayImpressions }}</div>
          <div>{{ scope.row.deliveryPerformance.last7DayImpressions }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Clicks" label="点击数" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.Clicks }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last90DayClicks }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last30DayClicks }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last14DayClicks }}</div>
          <div>{{ scope.row.deliveryPerformance.last7DayClicks }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.Orders }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last90DayOrders }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last30DayOrders }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last14DayOrders }}</div>
          <div>{{ scope.row.deliveryPerformance.last7DayOrders }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Units" label="商品数" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.Units }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last90DayUnits }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last30DayUnits }}</div>
          <div class="row-label">{{ scope.row.deliveryPerformance.last14DayUnits }}</div>
          <div>{{ scope.row.deliveryPerformance.last7DayUnits }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}</div>
          <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
            <div class="row-label">{{ (scope.row.deliveryPerformance.last90DayClickRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label">{{ (scope.row.deliveryPerformance.last30DayClickRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label">{{ (scope.row.deliveryPerformance.last14DayClickRate * 100).toFixed(2) + "%" }}</div>
            <div>{{ (scope.row.deliveryPerformance.last7DayClickRate * 100).toFixed(2) + "%" }}</div>
          </div>
          <div v-else>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Conversion Rate" label="转化率" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ Math.round(scope.row["Conversion Rate"] * 10000) / 100 + "%" }}</div>
          <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
            <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last90DayConversionRate')">{{ (scope.row.deliveryPerformance.last90DayConversionRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last30DayConversionRate')">{{ (scope.row.deliveryPerformance.last30DayConversionRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last14DayConversionRate')">{{ (scope.row.deliveryPerformance.last14DayConversionRate * 100).toFixed(2) + "%" }}</div>
            <div :class="getDeliveryConversionRateStyleClass(scope.row, 'last7DayConversionRate')">{{ (scope.row.deliveryPerformance.last7DayConversionRate * 100).toFixed(2) + "%" }}</div>
          </div>
          <div v-else>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.Spend.toFixed(2) }}</div>
          <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
            <div class="row-label">{{ scope.row.deliveryPerformance.last90DaySpend.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.deliveryPerformance.last30DaySpend.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.deliveryPerformance.last14DaySpend.toFixed(2) }}</div>
            <div>{{ scope.row.deliveryPerformance.last7DaySpend.toFixed(2) }}</div>
          </div>
          <div v-else>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label">{{ scope.row.Sales.toFixed(2) }}</div>
          <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
            <div class="row-label">{{ scope.row.deliveryPerformance.last90DaySales.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.deliveryPerformance.last30DaySales.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.deliveryPerformance.last14DaySales.toFixed(2) }}</div>
            <div>{{ scope.row.deliveryPerformance.last7DaySales.toFixed(2) }}</div>
          </div>
          <div v-else>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div class="row-label grayBg">{{ scope.row.ROAS.toFixed(2) }}</div>
          <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
            <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last90DayROAS')">{{ scope.row.deliveryPerformance.last90DayROAS.toFixed(2) }}</div>
            <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last30DayROAS')">{{ scope.row.deliveryPerformance.last30DayROAS.toFixed(2) }}</div>
            <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last14DayROAS')">{{ scope.row.deliveryPerformance.last14DayROAS.toFixed(2) }}</div>
            <div :class="getDeliveryROASStyleClass(scope.row, 'last7DayROAS')">{{ scope.row.deliveryPerformance.last7DayROAS.toFixed(2) }}</div>
          </div>
          <div v-else>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div class="row-label"></div>
            <div></div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="标题" width="80px" align="right">
        <div>
          <div class="row-label"></div>
          <div class="row-label">所有-近90日</div>
          <div class="row-label">所有-近30日</div>
          <div class="row-label">所有-近14日</div>
          <div>所有-近7日</div>
        </div>
      </el-table-column>
      <el-table-column label="CPC" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div v-if="Object.keys(scope.row.keywordAllPerformance).length !== 0">
            <div class="row-label">{{ scope.row.keywordAllPerformance.last90DayCPC.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.keywordAllPerformance.last30DayCPC.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.keywordAllPerformance.last14DayCPC.toFixed(2) }}</div>
            <div>{{ scope.row.keywordAllPerformance.last7DayCPC.toFixed(2) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="展现" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last90DayImpressions }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last30DayImpressions }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last14DayImpressions }}</div>
          <div>{{ scope.row.keywordAllPerformance.last7DayImpressions }}</div>
        </template>
      </el-table-column>
      <el-table-column label="点击数" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last90DayClicks }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last30DayClicks }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last14DayClicks }}</div>
          <div>{{ scope.row.keywordAllPerformance.last7DayClicks }}</div>
        </template>
      </el-table-column>
      <el-table-column label="订单数" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last90DayOrders }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last30DayOrders }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last14DayOrders }}</div>
          <div>{{ scope.row.keywordAllPerformance.last7DayOrders }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品数" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last90DayUnits }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last30DayUnits }}</div>
          <div class="row-label">{{ scope.row.keywordAllPerformance.last14DayUnits }}</div>
          <div>{{ scope.row.keywordAllPerformance.last7DayUnits }}</div>
        </template>
      </el-table-column>
      <el-table-column label="点击率" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div v-if="Object.keys(scope.row.keywordAllPerformance).length !== 0">
            <div class="row-label">{{ (scope.row.keywordAllPerformance.last90DayClickRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label">{{ (scope.row.keywordAllPerformance.last30DayClickRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label">{{ (scope.row.keywordAllPerformance.last14DayClickRate * 100).toFixed(2) + "%" }}</div>
            <div>{{ (scope.row.keywordAllPerformance.last7DayClickRate * 100).toFixed(2) + "%" }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="转化率" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div v-if="Object.keys(scope.row.keywordAllPerformance).length !== 0">
            <div class="row-label" :class="getConversionRateStyleClass(scope.row, 'last90DayConversionRate')">{{ (scope.row.keywordAllPerformance.last90DayConversionRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label" :class="getConversionRateStyleClass(scope.row, 'last30DayConversionRate')">{{ (scope.row.keywordAllPerformance.last30DayConversionRate * 100).toFixed(2) + "%" }}</div>
            <div class="row-label" :class="getConversionRateStyleClass(scope.row, 'last14DayConversionRate')">{{ (scope.row.keywordAllPerformance.last14DayConversionRate * 100).toFixed(2) + "%" }}</div>
            <div :class="getConversionRateStyleClass(scope.row, 'last7DayConversionRate')">{{ (scope.row.keywordAllPerformance.last7DayConversionRate * 100).toFixed(2) + "%" }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="花费" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div v-if="Object.keys(scope.row.keywordAllPerformance).length !== 0">
            <div class="row-label">{{ scope.row.keywordAllPerformance.last90DaySpend.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.keywordAllPerformance.last30DaySpend.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.keywordAllPerformance.last14DaySpend.toFixed(2) }}</div>
            <div>{{ scope.row.keywordAllPerformance.last7DaySpend.toFixed(2) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="销售" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div v-if="Object.keys(scope.row.keywordAllPerformance).length !== 0">
            <div class="row-label">{{ scope.row.keywordAllPerformance.last90DaySales.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.keywordAllPerformance.last30DaySales.toFixed(2) }}</div>
            <div class="row-label">{{ scope.row.keywordAllPerformance.last14DaySales.toFixed(2) }}</div>
            <div>{{ scope.row.keywordAllPerformance.last7DaySales.toFixed(2) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="ROAS" width="60px" align="right">
        <template slot-scope="scope">
          <div class="row-label"></div>
          <div v-if="Object.keys(scope.row.keywordAllPerformance).length !== 0">
            <div class="row-label" :class="getROASStyleClass(scope.row, 'last90DayROAS')">{{ scope.row.keywordAllPerformance.last90DayROAS.toFixed(2) }}</div>
            <div class="row-label" :class="getROASStyleClass(scope.row, 'last30DayROAS')">{{ scope.row.keywordAllPerformance.last30DayROAS.toFixed(2) }}</div>
            <div class="row-label" :class="getROASStyleClass(scope.row, 'last14DayROAS')">{{ scope.row.keywordAllPerformance.last14DayROAS.toFixed(2) }}</div>
            <div :class="getROASStyleClass(scope.row, 'last7DayROAS')">{{ scope.row.keywordAllPerformance.last7DayROAS.toFixed(2) }}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>

    <el-dialog title="新增关键词" :visible.sync="dialogFormVisible" width="25%">
      <el-form ref="form" label-width="80px">
        <el-form-item label="匹配类型">
          <el-radio-group v-model="matchType">
            <el-radio :label="1">精准匹配</el-radio>
            <el-radio :label="2">词组匹配</el-radio>
            <el-radio :label="3">宽泛匹配</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="新增类型">
          <el-radio-group v-model="addType">
            <el-radio :label="1">Asin</el-radio>
            <el-radio :label="2">商品</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="addType == 2">
          <el-form-item label="产品类型">
            <el-select placeholder="产品类型" size="small" v-model="addProductType">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="颜色">
            <el-select placeholder="产品类型" size="small" v-model="addProductColor">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="型号">
            <el-select placeholder="型号" size="small" v-model="addProductModel">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="投放价格">
          <el-input type="number" placeholder="请输入" v-model="recommandBid"> </el-input>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input type="textarea" :rows="10" placeholder="请输入关键词" v-model="keywordsText"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitKeywords">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="一键新增关键词" :visible.sync="autoAddDialogFormVisible" width="25%">
      <el-form ref="form" label-width="80px">
        <template>
          <el-form-item label="产品类型">
            <el-select placeholder="产品类型" size="small" v-model="autoAddProductType">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="autoAddDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAutoAddKeywords">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="一键调整关键词" :visible.sync="autoAdjustDialogFormVisible" width="420px">
      <el-form ref="form" label-width="80px">
        <template>
          <el-form-item label="产品类型">
            <el-select placeholder="请选择产品" size="small" multiple collapse-tags filterable :disabled="autoAdjustAllProducts" v-model="autoAdjustProductTypes" style="width: 100%">
              <el-option v-for="product in productList" :key="product.productType" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="范围">
            <el-checkbox v-model="autoAdjustAllProducts" @change="onAutoAdjustAllChange">全部在售产品</el-checkbox>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="autoAdjustDialogFormVisible = false" :disabled="autoAdjustLoading">取 消</el-button>
        <el-button type="primary" :loading="autoAdjustLoading" @click="submitAutoAdjustKeywords">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量KWModel" :visible.sync="batchUpdateKWModelDialogVisible" width="25%">
      <el-form ref="form" label-width="80px">
        <template>
          <el-form-item label="产品类型">
            <el-select placeholder="产品类型" size="small" v-model="batchUpdateKWModelParams.productType">
              <el-option label="请选择" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="KWModel">
            <el-input type="text" placeholder="请输入" v-model="batchUpdateKWModelParams.kwmodel"> </el-input>
          </el-form-item>
          <el-form-item label="匹配类型">
            <el-radio-group v-model="batchUpdateKWModelParams.matchType">
              <el-radio label="全部" value="全部">全部</el-radio>
              <el-radio label="精准" value="精准">精准</el-radio>
              <el-radio label="词组" value="词组">词组</el-radio>
              <el-radio label="广泛" value="广泛">广泛</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="batchUpdateKWModelParams.status">
              <el-radio :label="1" :value="1">启用</el-radio>
              <el-radio :label="2" :value="2">暂停</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchUpdateKWModelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatchUpdateKWModel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量改价" :visible.sync="dialogVisible" width="25%">
      <div class="dialog-content">
        <el-form ref="form" label-width="80px">
          <el-form-item label="操作类型">
            <el-radio-group v-model="changeType">
              <el-radio :label="1" :value="1">增加</el-radio>
              <el-radio :label="2" :value="2">减少</el-radio>
              <el-radio :label="3" :value="3">覆盖</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快捷选项" v-if="changeType != 3">
            <el-radio-group v-model="quickPrice" @input="onQuichPriceChange">
              <el-radio :label="0.05" :value="0.05">0.05</el-radio>
              <el-radio :label="0.1" :value="0.1">0.1</el-radio>
              <el-radio :label="0.2" :value="0.2">0.2</el-radio>
              <el-radio :label="0.3" :value="0.3">0.3</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="金额">
            <el-input type="number" placeholder="请输入" v-model="keywordPrice"> </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPrice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { products, activeProducts, colors, models } from "../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 68 - 60,
      total: 0,
      pageCount: 1,
      dialogFormVisible: false,
      dialogVisible: false,
      autoAddDialogFormVisible: false,
      autoAdjustDialogFormVisible: false,
      batchUpdateKWModelDialogVisible: false,
      totalPage: 1,
      advertData: [],
      keywordsText: "",
      matchType: 1,
      addType: 1,
      addProductType: "",
      addProductColor: "",
      addProductModel: "",
      autoAddProductType: "",
      autoAdjustProductTypes: [],
      autoAdjustAllProducts: false,
      autoAdjustLoading: false,
      recommandBid: 0.3,
      multipleSelection: [],
      changeType: 1,
      keywordPrice: 0.1,
      quickPrice: 0.1,
      asin: this.$route.query.asin,
      entity: this.$route.query.entity,
      productTargetingId: this.$route.query.productTargetingId,
      sku: "",
      productType: "",
      productColor: "",
      productModel: "",
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      date: "",
      batchUpdateKWModelParams: {
        productType: "",
        kwmodel: "",
        status: 1,
        matchType: "全部",
      },
      params: { pageSize: 50, sku: "", date: "", asin: this.$route.query.asin, Entity: "关键词", beginIndex: 0, productType: "", productColor: "", productModel: "", createType: 1, matchType: "", keywordModel: "", phoneModelKW: "", State: "", sortKey: "Spend", keyword: "" },
    };
  },
  watch: {
    "params.productType": {
      handler: function (newValue, oldValue) {
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        let checkModels = JSON.parse(parentProduct.checkModels);

        this.colorList = [];
        this.modelList = [...checkModels];

        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.params.productModel = productModel;
      },
    },
  },
  mounted() {
    // console.log(document.body.clientHeight)
    // console.log(this.screenHeight);
    // this.screenHeight = document.body.clientHeight - 55 - this.$refs.header.clientHeight - this.$refs.pageNav.$el.clientHeight
    // console.log(this.screenHeight, document.body.clientHeight, 55, this.$refs.header.clientHeight, this.$refs.pageNav.$el.clientHeight);
    this.getAdvertData();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    submitAutoAddKeywords() {
      this.autoAddDialogFormVisible = false;
      requestModules.autoAddManualKeywordsAdvert({ productType: this.autoAddProductType }).then(res => {
        this.$confirm("生成完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {});
      });
    },
    onAutoAdjustAllChange(checked) {
      if (checked) {
        this.autoAdjustProductTypes = [];
      }
    },
    getAutoAdjustProductName(productType) {
      const product = this.productList.find(pd => pd.productType == productType);
      return product && product.productName ? product.productName : String(productType);
    },
    submitAutoAdjustKeywords() {
      if (this.autoAdjustLoading) return;
      if (!this.autoAdjustAllProducts && this.autoAdjustProductTypes.length === 0) {
        this.$message({ type: "warning", message: "请选择产品类型" });
        return;
      }
      const productTypes = this.autoAdjustAllProducts ? "" : this.autoAdjustProductTypes.join(",");
      this.autoAdjustLoading = true;
      requestModules
        .autoAdjustManualKeywordsAdvert({ productTypes })
        .then(res => {
          const mdata = res.mdata || {};
          const items = mdata.items || [];
          if (!items.length) {
            this.$message({ type: "warning", message: res.message || "没有可调整的在售产品" });
            return;
          }
          this.autoAdjustDialogFormVisible = false;
          const failed = items.filter(item => item.error);
          let message = "共调整 " + (mdata.totalUpdated || 0) + " 条";
          if (failed.length) {
            message += "，失败产品：" + failed.map(item => this.getAutoAdjustProductName(item.productType) + "（" + item.error + "）").join("、");
          }
          this.$confirm(message, "提示", {
            confirmButtonText: "确定",
            type: failed.length ? "warning" : "info",
          })
            .then(() => {})
            .catch(() => {});
        })
        .catch(() => {})
        .finally(() => {
          this.autoAdjustLoading = false;
        });
    },
    autoAddKeywords() {
      this.autoAddDialogFormVisible = true;
    },
    autoAdjustKeywords() {
      this.autoAdjustDialogFormVisible = true;
    },
    submitBatchUpdateKWModel() {
      this.batchUpdateKWModelDialogVisible = false;
      requestModules.batchUpdateKWModel(this.batchUpdateKWModelParams).then(res => {
        this.$confirm("调整完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {});
      });
    },
    batchUpdateKWModel() {
      this.batchUpdateKWModelDialogVisible = true;
    },
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68 - 60;
    },
    autoAdjustBtn() {
      this.$confirm("是否确认一键调整?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let promiseList = [];
          this.tableData.forEach(data => {
            if (data.isPriceNeedUpdate || data.isStateNeedUpdate) {
              let params = {
                id: data._id,
              };
              data.isPriceNeedUpdate && (params.Bid = data.recommandBid);
              data.isStateNeedUpdate && (params.State = data.recommandState);

              promiseList.push(requestModules.updateProductAdvert(params).then(res => {}));
            }
          });
          Promise.all(promiseList).then(results => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    addKeywords() {
      this.dialogFormVisible = true;
    },
    submitKeywords() {
      let keywordSet = new Set(this.keywordsText.trim().split("\n"));
      let params = {
        asin: this.$route.query.asin,
        matchType: this.matchType,
        recommandBid: this.recommandBid,
        productType: this.addProductType,
        productColor: this.addProductColor,
        productModel: this.addProductModel.replace(/\s/g, ""),
        keywords: JSON.stringify(Array.from(keywordSet)),
      };
      requestModules.addManualKeywordAdvert(params).then(res => {
        console.log(res);
        this.getAdvertData();
      });
      this.dialogFormVisible = false;
    },
    startKWAdvertTask() {
      requestModules.runKeywordStatistics({}).then(res => {
        this.$confirm("生成完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {});
      });
    },
    onQuichPriceChange(val) {
      this.keywordPrice = val;
    },
    getRelateAsinLabel(asinsTrafficProportion, index) {
      if (!asinsTrafficProportion || asinsTrafficProportion.length < index + 1) {
        return "";
      }
      asinsTrafficProportion.sort((a, b) => b.percent - a.percent);
      return asinsTrafficProportion[index].productColor + "-" + asinsTrafficProportion[index].model + "-" + (asinsTrafficProportion[index].percent * 100).toFixed(2) + "%";
    },
    priceBtn() {
      if (this.multipleSelection.length <= 0) {
        this.$message({
          message: "请至少选择一条记录",
          type: "warning",
        });
      }
      this.dialogVisible = true;
    },
    submitPrice() {
      this.$confirm("是否确认批量修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.multipleSelection.forEach(advert => {
            let bid = Number(advert.Bid);
            let keywordPrice = Number(this.keywordPrice);
            this.changeType == 1 && (bid += keywordPrice);
            this.changeType == 2 && (bid -= keywordPrice);
            this.changeType == 3 && (bid = keywordPrice);
            let params = {
              id: advert._id,
              Bid: bid.toFixed(2),
            };
            requestModules.updateProductAdvert(params).then(res => {
              console.log(res);
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });

      this.dialogVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const { columns, data } = param;
      const sums = [];
      let impressions = 0;
      let clicks = 0;
      let orders = 0;
      let spend = 0;
      let sales = 0;
      const skipSumProps = new Set(["CPC", "Click-through Rate", "Conversion Rate", "ROAS", "Bid", "rank", "organicRank", "traffic", "recommandBid"]);
      const textLabels = new Set(["操作", "状态", "推荐状态", "产品信息", "关键词", "相关变体", "推荐标题", "推荐单价", "标题", "匹配类型"]);
      const perfPeriods = ["last90Day", "last30Day", "last14Day", "last7Day"];
      const allPerfTotals = {};

      perfPeriods.forEach(period => {
        allPerfTotals[period] = { impressions: 0, clicks: 0, orders: 0, units: 0, spend: 0, sales: 0 };
      });
      data.forEach(row => {
        const perf = row.keywordAllPerformance || {};
        perfPeriods.forEach(period => {
          allPerfTotals[period].impressions += Number(perf[period + "Impressions"]) || 0;
          allPerfTotals[period].clicks += Number(perf[period + "Clicks"]) || 0;
          allPerfTotals[period].orders += Number(perf[period + "Orders"]) || 0;
          allPerfTotals[period].units += Number(perf[period + "Units"]) || 0;
          allPerfTotals[period].spend += Number(perf[period + "Spend"]) || 0;
          allPerfTotals[period].sales += Number(perf[period + "Sales"]) || 0;
        });
      });

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (textLabels.has(column.label) || !column.property || skipSumProps.has(column.property)) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
        } else {
          sums[index] = "";
        }
        column.property === "Impressions" && (impressions = sums[index]);
        column.property === "Clicks" && (clicks = sums[index]);
        column.property === "Orders" && (orders = sums[index]);
        column.property === "Spend" && (spend = sums[index]);
        column.property === "Sales" && (sales = sums[index]);
      });

      const formatAllPerfSummary = (period, label) => {
        const total = allPerfTotals[period];
        if (label === "展现") {
          return total.impressions || "";
        }
        if (label === "点击数") {
          return total.clicks || "";
        }
        if (label === "订单数") {
          return total.orders || "";
        }
        if (label === "商品数") {
          return total.units || "";
        }
        if (label === "花费") {
          return total.spend > 0 ? total.spend.toFixed(2) : "";
        }
        if (label === "销售") {
          return total.sales > 0 ? total.sales.toFixed(2) : "";
        }
        if (label === "CPC") {
          return total.clicks > 0 ? (total.spend / total.clicks).toFixed(2) : "";
        }
        if (label === "点击率") {
          return total.impressions > 0 ? ((total.clicks / total.impressions) * 100).toFixed(2) + "%" : "";
        }
        if (label === "转化率") {
          return total.clicks > 0 ? ((total.orders / total.clicks) * 100).toFixed(2) + "%" : "";
        }
        if (label === "ROAS") {
          return total.spend > 0 ? (total.sales / total.spend).toFixed(2) : "";
        }
        return "";
      };

      columns.forEach((column, index) => {
        if (column.property === "CPC") {
          sums[index] = clicks > 0 ? (spend / clicks).toFixed(2) : "";
        }
        if (column.property === "Click-through Rate") {
          sums[index] = impressions > 0 ? ((clicks / impressions) * 100).toFixed(2) + "%" : "";
        }
        if (column.property === "Conversion Rate") {
          sums[index] = clicks > 0 ? ((orders / clicks) * 100).toFixed(2) + "%" : "";
        }
        if (column.property === "ROAS") {
          sums[index] = spend > 0 ? (sales / spend).toFixed(2) : "";
        }
        if ((column.property === "Spend" || column.property === "Sales") && sums[index] !== "") {
          sums[index] = Number(sums[index]).toFixed(2);
        }
        if (!column.property && column.label && ["展现", "点击数", "订单数", "商品数", "CPC", "点击率", "转化率", "花费", "销售", "ROAS"].includes(column.label)) {
          sums[index] = formatAllPerfSummary("last90Day", column.label);
        }
      });

      return sums;
    },
    onStateChange(row) {
      // debugger
      // row.State = row.State == "enabled" ? "paused" : "enabled";
      let params = {
        id: row._id,
        State: row.State,
      };
      requestModules.updateProductAdvert(params).then(res => {
        console.log(res);
      });
    },
    onDailyBudgetChange(row) {},
    onBidChange(row) {
      this.$confirm("是否确认修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            Bid: row.Bid,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onRecommandBidClick(row) {
      this.$confirm("是否确认修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            Bid: row.recommandBid,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            row.Bid = row.recommandBid;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getRecommandStateStyleClass(row) {
      let styleClass = "";
      row.recommandState == "暂停" && row.State == "已启用" && (styleClass = "redBg");
      row.recommandState == "启用" && row.State == "已暂停" && (styleClass = "greenBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getRecommandBidStyleClass(row) {
      let styleClass = "";
      row.recommandBid > row.Bid && (styleClass = "greenBg");
      row.recommandBid < row.Bid && (styleClass = "redBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryConversionRateStyleClass(row, key) {
      if (!row || !row.deliveryPerformance) {
        return "";
      }
      let conversionRate = row.deliveryPerformance[key];
      let styleClass = "";
      conversionRate >= 0.15 && (styleClass = "greenBg");
      conversionRate < 0.1 && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryROASStyleClass(row, key) {
      if (!row || !row.deliveryPerformance) {
        return "";
      }
      let roas = row.deliveryPerformance[key];
      let styleClass = "";
      roas >= 3 && (styleClass = "greenBg");
      roas < 1 && (styleClass = "redBg");
      return styleClass;
    },
    getConversionRateStyleClass(row, key) {
      if (!row || !row.keywordAllPerformance) {
        return "";
      }
      let conversionRate = row.keywordAllPerformance[key];
      let styleClass = "";
      conversionRate >= 0.15 && (styleClass = "greenBg");
      conversionRate < 0.1 && (styleClass = "redBg");
      return styleClass;
    },
    getROASStyleClass(row, key) {
      if (!row || !row.keywordAllPerformance) {
        return "";
      }
      let roas = row.keywordAllPerformance[key];
      let styleClass = "";
      roas >= 3 && (styleClass = "greenBg");
      roas < 1 && (styleClass = "redBg");
      return styleClass;
    },
    getRecommandTypeLabel(recommandType) {
      let text = "";
      recommandType == 1 && (text = "投放");
      recommandType == 2 && (text = "90日成交词模型");
      recommandType == 3 && (text = "关键词");
      recommandType == 4 && (text = "默认");
      recommandType == 5 && (text = "90日长尾词模型");
      recommandType == 7 && (text = "30日长尾词模型");
      recommandType == 6 && (text = "7日长尾词模型");
      recommandType == 8 && (text = "7日成交词模型");
      recommandType == 9 && (text = "30日成交词模型");
      recommandType == 10 && (text = "核心关键词");
      return text;
    },
    getAdvertData() {
      requestModules.fetchKeywordAdverts(this.params).then(res => {
        this.advertData = res.ldata;
        this.total = res.total;
      });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAdvertData();
    },
    load(tree, treeNode, resolve) {
      let params = { pageSize: 10000, campaignName: tree["Campaign Name (Informational only)"], adGroupName: tree["Ad Group Name (Informational only)"], keyword: tree["Keyword Text"] };
      requestModules.fetchDetailKeywordAds(params).then(res => {
        resolve(res.ldata);
      });
    },
    keywordAnalysis(row) {
      // let adGroupName = row["Ad Group Name (Informational only)"];

      window.open("/client/searchKeywordMgmt/keywordAnalysis?keyword=" + row["Keyword Text"] + "&asin=" + row.asin + "&campaignName=" + row["Campaign Name (Informational only)"] + "&adGroupName=" + row["Ad Group Name (Informational only)"] + "&productType=" + row.productType);
    },
  },
  computed: {
    tableData() {
      let list = [...this.advertData];

      list.forEach(advert => {
        advert.hasChildren = true;
        advert.children = [];

        // let defaultBid = 0.3;
        // let defaultConversionRate = 0.1;
        // let recommandBid = advert.Bid;
        // let adjustBid = 0.05;
        // let deliveryPerformance = advert.deliveryPerformance;
        // let keywordAllPerformance = advert.keywordAllPerformance;
        // if (deliveryPerformance && deliveryPerformance.last90DayImpressions) {
        //   if (deliveryPerformance.last90DayConversionRate > 0 || deliveryPerformance.last90DayClicks > 20) {
        //     console.log(deliveryPerformance.last90DayConversionRate - defaultConversionRate, (deliveryPerformance.last90DayConversionRate - defaultConversionRate) / 0.05);
        //     recommandBid = defaultBid + adjustBid * ((deliveryPerformance.last90DayConversionRate - defaultConversionRate) / 0.05);
        //   } else if (keywordAllPerformance.last90DayConversionRate > 0 || keywordAllPerformance.last90DayClicks > 20) {
        //     recommandBid = defaultBid + adjustBid * ((keywordAllPerformance.last90DayConversionRate - defaultConversionRate) / 0.05);
        //   } else {
        //     recommandBid = defaultBid;
        //   }

        //   if (deliveryPerformance.last30DayConversionRate > 0 || deliveryPerformance.last30DayClicks > 20) {
        //     recommandBid += defaultBid * (deliveryPerformance.last30DayConversionRate - deliveryPerformance.last90DayConversionRate);
        //   }
        //   if (deliveryPerformance.last14DayConversionRate > 0 || deliveryPerformance.last14DayClicks > 20) {
        //     recommandBid += defaultBid * (deliveryPerformance.last14DayConversionRate - deliveryPerformance.last30DayConversionRate);
        //   }
        //   if (deliveryPerformance.last7DayConversionRate > 0 || deliveryPerformance.last7DayClicks > 20) {
        //     recommandBid += defaultBid * (deliveryPerformance.last7DayConversionRate - deliveryPerformance.last14DayConversionRate);
        //   }

        //   if (deliveryPerformance.last90DayROAS > 3) {
        //     recommandBid += 0.05;
        //   }

        //   if (recommandBid > 0.45) {
        //     recommandBid = 0.45;
        //   }
        // }
        // console.log(recommandBid);
        // advert.recommandBid = parseFloat(recommandBid).toFixed(2);
        advert.isPriceNeedUpdate = advert.recommandBid != advert.Bid;
        // console.log(advert.recommandBid, advert.Bid);

        let recommandState = advert.State;

        // if (deliveryPerformance.last90DayClicks > 20) {
        //   if (deliveryPerformance.last90DayConversionRate > 0.1) {
        //     recommandState = "已启用";
        //   } else {
        //     recommandState = "已暂停";
        //   }
        // } else {
        //   recommandState = "已启用";
        // }

        // if (advert.State == "已启用") {
        //   if (deliveryPerformance.last90DayConversionRate > 0.1 || keywordAllPerformance.last90DayConversionRate > 0.15 || deliveryPerformance.last30DayConversionRate > 0.1 || keywordAllPerformance.last30DayConversionRate > 0.15 || deliveryPerformance.last14DayConversionRate > 0.1 || keywordAllPerformance.last14DayConversionRate > 0.15 || deliveryPerformance.last7DayConversionRate > 0.1 || keywordAllPerformance.last7DayConversionRate > 0.15) {
        //     recommandState = "启用";
        //   } else {
        //     // if (deliveryPerformance.last90DayClicks > 20 || keywordAllPerformance.last90DayClicks > 20 || deliveryPerformance.last30DayClicks > 15 || keywordAllPerformance.last30DayClicks > 15 || deliveryPerformance.last14DayClicks > 10 || keywordAllPerformance.last14DayClicks > 10 || deliveryPerformance.last7DayClicks > 10 || keywordAllPerformance.last7DayClicks > 10) {
        //     recommandState = "暂停";
        //     // } else {
        //     //   recommandState = "启用";
        //     // }
        //   }
        // } else {
        //   if ((keywordAllPerformance.last90DayOrders >= 2 && keywordAllPerformance.last90DayConversionRate > 0.15) || (keywordAllPerformance.last30DayOrders >= 2 && keywordAllPerformance.last30DayConversionRate > 0.15) || (keywordAllPerformance.last14DayOrders >= 2 && keywordAllPerformance.last14DayConversionRate > 0.15) || (keywordAllPerformance.last7DayOrders >= 2 && keywordAllPerformance.last7DayConversionRate > 0.15)) {
        //     recommandState = "启用";
        //   } else {
        //     recommandState = "暂停";
        //   }
        // }
        advert.recommandState = recommandState;
        // console.log(advert.recommandState, advert.State);
        advert.isStateNeedUpdate = advert.recommandState != advert.State;

        console.log("isStateNeedUpdate", advert.isStateNeedUpdate, "isPriceNeedUpdate", advert.isPriceNeedUpdate);
      });
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      return list;
    },
  },
};
</script>

<style lang="scss">
#DeliveryKeywordMgmt {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }

    .grayBg {
    }

    .redText {
      color: red;
    }

    .row-label {
      height: 16px;
      line-height: 16px;
      border-bottom: solid 1px #ebeef5;
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
